import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { authService } from '../auth/AuthService'
import { Loading } from '../components/Loading'
import { sanitizeInternalPath } from '../utils/safe-redirect'

export function CallbackPage() {
  const navigate = useNavigate()
  const hasProcessedCallback = useRef(false)

  useEffect(() => {
    // Guard against React StrictMode double-mounting in development
    if (hasProcessedCallback.current) {
      return
    }
    hasProcessedCallback.current = true

    authService.signinRedirectCallback()
      .then(() => {
        const redirectUri = sanitizeInternalPath(sessionStorage.getItem('redirectUri'))
        sessionStorage.removeItem('redirectUri')
        navigate(redirectUri, { replace: true })
      })
      .catch((error) => {
        console.error('Callback error:', error)
        navigate('/', { replace: true })
      })
  }, [navigate])

  return <Loading />
}
